import React, { useEffect, useState } from "react";
import { Modal } from "react-materialize";
import { useMediaQuery } from "react-responsive";
import Walletbankdetails from "../children/Walletbankdetails";
import WalletUpdateBank from "../children/WalletUpdateBank";
import { useDispatch, useSelector } from "react-redux";
import { getWalletAction } from "../../../../redux/action/wallet";
import LoadingSkeleton from "../../../loader/TableLoader";
import Pagination from "../../pagination/Pagination";
import { NoItemsLeftInTable } from "../../../../helpers/helpers";

function AccountHolderTable() {
  const totalNumberRow = 30;
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const dispatch = useDispatch();
  const { wallet, loading } = useSelector((state) => state.wallet);
  const [personalDetails, setPersonalDetails] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [accountDetailTable, setAccountDetailTable] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const viewDetailsFunctionality = (items) => {
    setPersonalDetails(items);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    dispatch(getWalletAction());
  }, [dispatch]);

  useEffect(() => {
    setAccountDetailTable(wallet?.bankAccounts?.reverse());
  }, [wallet, dispatch]);

  if (loading) {
    return (
      <div className="valign-wrapper justify-center cover white">
        <LoadingSkeleton
          headerData={[
            "Account Number",
            "Bank name",
            "IFSC code",
            "Branch",
            "Name",
            "Status",
            "Actions",
          ]}
        />
      </div>
    );
  }

  return (
    <div>
      <div className={`table-container-style z-depth-1`}>
        <table
          className={`responsive-table centered ${isTablet ? "auction_table table-style" : "custom-table-style"
            } `}
        >
          <thead>
            <tr>
              <th>Account Number</th>
              <th>Bank name</th>
              <th>IFSC code</th>
              <th>Branch</th>
              <th>Name</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {accountDetailTable
              ?.slice(currentPage, currentPage + totalNumberRow)
              ?.map((items, index) => (
                <tr key={items.id} className="text-bold">
                  <td>{items?.accountNo}</td>
                  <td>{items?.bankName}</td>
                  <td>{items?.IFCSCode}</td>
                  <td>{items?.bankBranch}</td>
                  <td>{items?.holderName}</td>

                  <td>
                    <span
                      className="valign-wrapper justify-center"
                      style={{ gap: "10px" }}
                    >
                      <span>
                        {" "}
                        {items.verified ? "Verified" : "Not Verified"}
                      </span>
                      {items?.verified ? (
                        <img
                          src={`${process.env.PUBLIC_URL}/icons/Icon.svg`}
                          alt="Icon"
                          style={{ width: "18px", height: "18px" }}
                        />
                      ) : (
                        <img
                          src={`${process.env.PUBLIC_URL}/icons/info-circle.svg`}
                          alt="Icon"
                          className="pointer "
                          style={{ width: "20px", height: "20px" }}
                        />
                      )}
                    </span>
                  </td>
                  <td>
                    <img
                      src={`${process.env.PUBLIC_URL}/icons/visibility.svg`}
                      alt="Icon"
                      className="pointer"
                      style={{ width: "23px" }}
                      onClick={() => viewDetailsFunctionality(items)}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        {accountDetailTable?.length === 0 && (
        <NoItemsLeftInTable />
      )}
      </div>
     
      {accountDetailTable?.length !== 0 && (
        <Pagination
          Data={accountDetailTable}
          totalNumberRow={totalNumberRow}
          setCurrentPage={setCurrentPage}
        />
      )}

      <Modal
        actions={[]}
        bottomSheet={false}
        fixedFooter={false}
        className="modelAccount"
        id="modalAccount-details"
        open={isModalOpen}
        options={{
          onCloseEnd: closeModal,
        }}
      >
        <Walletbankdetails bankDetail={personalDetails} />
      </Modal>

      <Modal
        actions={[]}
        bottomSheet={false}
        fixedFooter={false}
        className="modelAccount"
        id="modalAccountUpdate"
        open={false}
      >
        <WalletUpdateBank />
      </Modal>
    </div>
  );
}

export default AccountHolderTable;
